let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fNx04")).then(() => parcelRequire('9o9gx'));